// Regexp taken from 3. solution provided here:
//  https://docs.google.com/document/d/1At-17S78kXI7PHvKtYnPJ6pzbhcaxBpBYZacN6aIWoU/edit
export const URL_REGEX =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/;
